import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { MobileAppButton, QRCode } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { NText } from '@fttb/common/components';

// fixme
import { getAppDownloadLink, getAppDownloadList, getAppDownloadText, isRenderAppDownloadPopup } from "../../../../store/blocks/infoCards/selectors";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var _AppDownloadPopup = function _AppDownloadPopup(_ref) {
  var link = _ref.link,
    list = _ref.list,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(React.Fragment, null, link && /*#__PURE__*/React.createElement(QRCode, {
    link: link,
    size: 156,
    "data-t-id": "components-AppDownloadPopup"
  }), /*#__PURE__*/React.createElement(NText, {
    className: "mar-b-xs mar-t-xl",
    isInline: false,
    size: "size5-m"
  }, text), /*#__PURE__*/React.createElement("div", {
    className: cx('apps-table')
  }, list.map(function (app) {
    return /*#__PURE__*/React.createElement(MobileAppButton, {
      backgroundColor: "black",
      href: app.href,
      isFullWidth: true,
      variant: app.variant
    });
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    link: getAppDownloadLink(state),
    list: getAppDownloadList(state),
    shouldRender: isRenderAppDownloadPopup(state),
    text: getAppDownloadText(state)
  };
};
var connector = connect(mapStateToProps);
export var AppDownloadPopup = compose(connector, withRenderFlag)(_AppDownloadPopup);